import React from "react";

function eloTier(elo) {
  if (elo >= 2000) return { label: "Master", className: "bg-brand text-brand-foreground" };
  if (elo >= 1700) return { label: "Diamond", className: "bg-foreground text-background" };
  if (elo >= 1400) return { label: "Gold", className: "bg-[hsl(var(--chart-3))] text-background" };
  if (elo >= 1100) return { label: "Silver", className: "bg-muted text-foreground" };
  return { label: "Bronze", className: "bg-surface text-muted-foreground" };
}

export default function EloBadge({ elo, showLabel = true, size = "md" }) {
  const t = eloTier(elo);
  const sizes = {
    sm: "text-xs px-2.5 py-1",
    md: "text-sm px-3 py-1.5",
    lg: "text-base px-4 py-2",
  };
  return (
    <div className="inline-flex items-center gap-2" data-testid="elo-badge">
      <span className={`font-display font-bold tracking-tight rounded-full ${sizes[size]} ${t.className}`}>
        {elo} ELO
      </span>
      {showLabel && (
        <span className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">{t.label}</span>
      )}
    </div>
  );
}
